import { motion } from 'framer-motion'
import { Scale, Heart, Users, HardHat } from 'lucide-react'
import { SectionLabel } from '../ui/SectionLabel'

const industries = [
  {
    icon: Scale,
    name: 'Legal & Professional Services',
    body: 'Client confidentiality is non-negotiable. We build compliant, secure environments for law firms, accounting practices, and consultants across the Pacific Northwest.',
  },
  {
    icon: Heart,
    name: 'Healthcare & Medical Practices',
    body: 'HIPAA-compliant infrastructure, secure patient data handling, and the uptime your practice depends on — managed so your staff stays focused on patients, not passwords.',
  },
  {
    icon: Users,
    name: 'Nonprofits & Social Services',
    body: 'We understand tight budgets and give you enterprise-grade protection at SMB pricing. Head Start of Yamhill County trusts us with their entire operation.',
  },
  {
    icon: HardHat,
    name: 'Construction & Trades',
    body: "Field teams, multiple sites, devices that need to work anywhere. We keep your crew connected and your files accessible whether they're in the office or on the job.",
  },
]

export function Industries() {
  return (
    <section style={{ padding: '120px 0', background: 'var(--bg-2)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16"
        >
          <SectionLabel className="mb-6">Who We Serve</SectionLabel>
          <h2
            style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(38px, 5vw, 60px)',
              textTransform: 'uppercase',
              lineHeight: 1.0,
              color: 'var(--white)',
            }}
          >
            Built for Pacific Northwest businesses that can't afford downtime.
          </h2>
          <p
            style={{
              fontSize: 16,
              color: 'var(--white-dim)',
              marginTop: 20,
              maxWidth: 520,
              lineHeight: 1.65,
            }}
          >
            We specialize in industries where data security, reliability, and compliance aren't optional.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[3px] mt-16">
          {industries.map((ind, i) => (
            <motion.div
              key={ind.name}
              initial={false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="industry-card flex gap-6 items-start transition-colors duration-220"
              style={{
                background: 'var(--bg-3)',
                padding: 44,
              }}
            >
              <div
                style={{
                  fontSize: 24,
                  flexShrink: 0,
                  width: 52,
                  height: 52,
                  background: 'var(--accent-glow)',
                  border: '1px solid var(--accent-line)',
                  borderRadius: 3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ind.icon className="w-6 h-6" style={{ color: 'var(--accent)' }} />
              </div>
              <div>
                <h3
                  style={{
                    fontFamily: 'Barlow Condensed, sans-serif',
                    fontWeight: 800,
                    fontSize: 22,
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    marginBottom: 8,
                    color: 'var(--white)',
                  }}
                >
                  {ind.name}
                </h3>
                <p
                  style={{
                    fontSize: 16,
                    lineHeight: 1.65,
                    color: 'var(--white-dim)',
                  }}
                >
                  {ind.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <style>{`
        .industry-card:hover { background: var(--bg-4) !important; }
      `}</style>
    </section>
  )
}
